// extracted by mini-css-extract-plugin
export default {"container":"confirm-payment-method-popup_container__1q8N9","buttons-container":"confirm-payment-method-popup_buttons-container__PhyY+"};